@if (backendAvailable$ | async) {
  @if (translateReady$ | async) {
    <router-outlet></router-outlet>
  }
  @if (hasValidSession()) {
    <app-async-task-progress></app-async-task-progress>
    <app-system-updates-panel></app-system-updates-panel>
  }
} @else {
  <app-backend-error></app-backend-error>
}
